var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6693 7.99967C14.6693 11.6815 11.6845 14.6663 8.0026 14.6663C4.3207 14.6663 1.33594 11.6815 1.33594 7.99967C1.33594 4.31777 4.3207 1.33301 8.0026 1.33301C10.1837 1.33301 12.1201 2.38041 13.3364 3.99967V1.33301",
    stroke: "#185CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshNew);
export default __webpack_public_path__ + "static/media/refresh-new.ec2268d4d5b48831d6793590e6fe0c4c.svg";
export { ForwardRef as ReactComponent };